import { create } from "zustand";
import { AppRole, inviteAccept, inviteDetails, inviteUser, register } from "./actions";
import * as FingerprintJS from '@fingerprintjs/fingerprintjs';

export type UserData = {
    uname: string
    pass: string
    mobile: string
    email: string
    displayName: string
    access: string
}

export type InviteDetails = {
    com: string
    app: string
    roles: string[]
    icon?: string
}


type RegProps = {
    loading: boolean
    accessCode: string
    email: string
    inviteDetails: InviteDetails | null
    inviteErr: string
    acceptInvite: (access: string, email: string) => Promise<any>
    reg: (userdata: UserData) => Promise<string>
    invite: (email: string, roles: AppRole[]) => Promise<string>
    inviteMultiple: (emails: string[], roles: AppRole[]) => Promise<string>
    retrieveInviteDetails: (access: string, email: string) => Promise<void>
}


export const useReg = create<RegProps>((set, getState) => ({
    accessCode: "",
    loading: true,
    email: "",
    inviteDetails: null,
    inviteErr: "",
    async acceptInvite(access, email) {
        set(state => ({ accessCode: access, email: email, loading: true }))
        const res = await inviteAccept(access, email)
        set(state => ({ loading: false }))
        return res
    },
    async reg(userdata) {
        if (getState().loading) return ""
        set(state => ({ loading: true }))
        const data = { ...userdata }
        data.mobile = btoa(data.mobile)
        data.pass = btoa(data.pass)
        data.uname = btoa(data.uname)
        data.access = getState().accessCode
        data.email = getState().email

        try {
            const fpPromise = FingerprintJS.load();
            const fp = await fpPromise;
            const result = await fp.get();
            const visitorId = result.visitorId;
            (data as any).dcd = btoa(visitorId);
        } catch (err) {
            console.error("Failed to get device ID:", err);
        }

        const res = await register(data)
        set(state => ({ loading: false }))
        return res
    },
    async invite(email, roles) {
        const res = await inviteUser(email, roles)
        return res.Code
    },
    async inviteMultiple(emails: string[], roles: AppRole[]) {
        const results = await Promise.all(emails.map(email => inviteUser(email, roles)));
        // Return codes or some aggregate result. For now, let's just return the first failure or 200 if all good.
        // Or better, return a list of failed emails?
        // The UI expects a single code in current usage, but we can change that consumption.
        // For simplicity in this step, let's return "200" if all succeed, or error code if any fails.
        const error = results.find(r => r.Code !== "200");
        return error ? error.Code : "200";
    },
    async retrieveInviteDetails(access, email) {
        const res = await inviteDetails(email, access)
        set(state => ({ accessCode: access, email: email, loading: true }))
        if (res.Code !== "200") {
            set(state => ({ inviteErr: res.Code, loading: false }))
        } else {
            const details = res.Msg
            set(state => ({ inviteDetails: details, loading: false }))
        }
    },
}))